"use client";

import { useEffect, useState } from "react";

function getMsUntilNextUtcMidnight(now: Date): number {
  const nextMidnight = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate() + 1);
  return nextMidnight - now.getTime();
}

function formatUtcCountdown(ms: number): string {
  const totalSeconds = Math.max(0, Math.ceil(ms / 1000));
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(seconds).padStart(2, "0")}`;
}

const COUNTDOWN_PLACEHOLDER = "--:--:--";

export function useUtcMidnightCountdown(): string {
  const [countdown, setCountdown] = useState(COUNTDOWN_PLACEHOLDER);

  useEffect(() => {
    const update = () => {
      const next = formatUtcCountdown(getMsUntilNextUtcMidnight(new Date()));
      setCountdown((current) => (current === next ? current : next));
    };

    update();
    const intervalId = setInterval(update, 1000);
    return () => clearInterval(intervalId);
  }, []);

  return countdown;
}
